if (!Object.fromEntries) {
    Object.defineProperty(Object, 'fromEntries', {
        value(entries) {
            if (!entries) { throw new Error('Object.fromEntries() requires a single iterable argument'); }

            const o = {};

            Object.keys(entries).forEach((key) => {
                const [k, v] = entries[key];

                o[k] = v;
            });

            return o;
        },
    });
}


// WEBPACK FOOTER //
// ./sources/js/polyfill/fromEntries.js